import phoneOptionsTemplate from 'components/Select/phone_options.json';

export function splitPhoneNumber(phone) {
  let phoneCountry = '';
  let phoneRemaining = phone;
  if (phone) {
    let matchedLength = 0;
    for (const phoneOption of phoneOptionsTemplate) {
      const phoneOptionCountry = phoneOption.value;
      const phoneOptionCountryLength = phoneOptionCountry.length;
      if (phone.startsWith(phoneOptionCountry) && matchedLength < phoneOptionCountryLength) {
        phoneCountry = phoneOptionCountry;
        matchedLength = phoneOptionCountryLength;
      }
    }
    if (phoneCountry) {
      phoneRemaining = phone.slice(phoneCountry.length).trim();
    }
  }
  return [phoneCountry, phoneRemaining];
};
